import { render, staticRenderFns } from "./AddResourceInformationModal.vue?vue&type=template&id=6ad2149c&scoped=true"
import script from "./AddResourceInformationModal.vue?vue&type=script&lang=ts"
export * from "./AddResourceInformationModal.vue?vue&type=script&lang=ts"
import style0 from "./AddResourceInformationModal.vue?vue&type=style&index=0&id=6ad2149c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad2149c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ad2149c')) {
      api.createRecord('6ad2149c', component.options)
    } else {
      api.reload('6ad2149c', component.options)
    }
    module.hot.accept("./AddResourceInformationModal.vue?vue&type=template&id=6ad2149c&scoped=true", function () {
      api.rerender('6ad2149c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/AddResourceInformationModal.vue"
export default component.exports